<template>
  <v-container grid-list-lg fluid>
    <PaymentMethodLine v-if="!$vuetify.breakpoint.xsOnly" />
    <List />
  </v-container>
</template>

<script>
import PaymentMethodLine from "@/modules/Invoice//Payment/Chart/PaymentMethodLine";
import List from "@/modules/Invoice/Payment/components/PaymentList.vue";
export default {
  components: {
    PaymentMethodLine,
    List
  }
};
</script>

<style scoped></style>
